import axios from "axios";
import { API_BASE_URL } from "config";
const usePrompts = async () => {
  const authToken = localStorage.getItem("authToken");
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${API_BASE_URL}/get_prompt_questions`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    const { data } = await axios.request(config);
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

export default usePrompts;
